import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Crown, Sparkles, Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { startCheckout } from "@/lib/premium";
import { formatError } from "@/lib/api";
import { PREMIUM } from "@/constants/testIds/premium";

// Discreet, professional Premium banner for the Home screen.
export const PremiumCTA = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await startCheckout();
    } catch (e) {
      setLoading(false);
      toast.error(formatError(e.response?.data?.detail) || "Não foi possível abrir o checkout.");
    }
  };

  return (
    <div
      data-testid={PREMIUM.ctaBanner}
      className="gold-glow relative overflow-hidden rounded-2xl border border-amber-400/30 bg-gradient-to-br from-slate-800 to-slate-900 p-6 sm:p-7"
    >
      <div className="absolute -right-8 -top-8 h-40 w-40 rounded-full bg-amber-500/10 blur-2xl" />
      <div className="relative flex flex-col gap-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-xl">
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full border border-amber-400/40 bg-amber-400/10 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-amber-300">
            <Sparkles className="h-3 w-3" /> Plano Premium
          </span>
          <h3 className="text-xl font-extrabold text-white sm:text-2xl">
            Questões e simulados ilimitados
          </h3>
          <p className="mt-1 text-sm text-slate-400">
            Desbloqueie tudo por{" "}
            <span data-testid={PREMIUM.planPrice} className="font-bold text-amber-300">R$ 19,90/mês</span>.{" "}
            <span data-testid={PREMIUM.trialBadge} className="font-semibold text-emerald-400">7 dias grátis</span> para começar.
          </p>
        </div>

        <div className="flex shrink-0 flex-col gap-2 sm:items-end">
          <button
            data-testid={PREMIUM.ctaButton}
            onClick={handleClick}
            disabled={loading}
            className="group flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 px-5 py-3 text-sm font-bold text-slate-950 shadow-lg transition-all hover:from-amber-400 hover:to-amber-500 hover:shadow-amber-500/30 active:scale-95 disabled:opacity-70"
          >
            {loading ? (
              <><Loader2 className="h-4 w-4 animate-spin" /> Abrindo checkout…</>
            ) : (
              <><Crown className="h-4 w-4" /> Assinar Premium <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" /></>
            )}
          </button>
          <button
            onClick={() => navigate("/premium")}
            className="text-xs font-semibold text-slate-400 underline-offset-4 transition-colors hover:text-slate-200 hover:underline"
            data-testid="premium-see-details"
          >
            Ver detalhes do plano
          </button>
        </div>
      </div>
    </div>
  );
};
